import React from 'react';

const TableSelectContext = React.createContext({
  select: false,
  selected: false,
  selectRange: {x1:-1,x2:-1,y1:-1, y2:-1},
  startSelect: ()=>{},
  moveSelect: ()=>{},
  stopSelect: ()=>{}
});

export const TableSelectProvider = ({children, ...rest}) => {
  return(
    <TableSelectContext.Provider value={rest}>
      {children}
    </TableSelectContext.Provider>
  )
}

export function useTableSelect() {
  return React.useContext(TableSelectContext);
}
